import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";

export default class ContactForm extends Component {

	constructor(props) {
      super(props);
      this.state = {
        name: '',
        email:'',
        phone:'',
        comment:'',
        message:'',
        type:'private',
        location:'in-person',
        isSubmitting: false,
        submitSuccess: false
      };
  }

  handleChange = (e) => {
	var name = e.target.name;
    var value = e.target.value;
    
    if(name === 'type' && value === "group" && this.state.location !== "online"){
      alert('Group classes can only be taken online')
      this.setState({[name]: value, location:'online'});
    } else if(name === 'type' && value !== "group"){
        this.setState({[name]: value});
    }
    else if(this.state.type === 'group' && name === 'location' && value !== "online"){
        alert('Group classes can only be taken online')
    }
    else{
      this.setState({[name]: value});
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submission started with Web3Forms');
    console.log('Form state:', this.state);

    this.setState({ isSubmitting: true });

    const formData = new FormData();
    
    // Web3Forms access key
    formData.append('access_key', '01b8eb46-99ca-4368-b010-df180d27e66f');
    
    // Basic form fields
    formData.append('name', this.state.name);
    formData.append('subject', this.props.subject || 'Contact Form Submission');
    
    if(this.props.email){
      formData.append('email', this.state.email);
    }
    if(this.props.phone){
      formData.append('phone', this.state.phone);
    }
    if(this.props.message){
      formData.append('message', this.state.message);
    }
    if(this.props.type){
      formData.append('type', this.state.type);
    }
    if(this.props.location){
      formData.append('location', this.state.location);
    }
    
    // Add any additional comments
    if(this.state.comment){
      formData.append('comment', this.state.comment);
    }

    // Don't use redirect in formData, handle it manually instead
    // formData.append('redirect', `${window.location.origin}/thankyou`);

    try {
      console.log('Sending request to Web3Forms API');
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      // Try to parse the response
      let result;
      try {
        result = await response.json();
        console.log('Web3Forms response:', result);
      } catch (parseError) {
        console.log('Could not parse JSON response:', parseError);
        const textResponse = await response.text();
        console.log('Raw response text:', textResponse);
        result = { success: response.ok };
      }

      // Check for success - Web3Forms typically returns response.ok = true for success
      if (response.ok || (result && result.success)) {
        console.log('Form submitted successfully');
        this.setState({ 
          submitSuccess: true,
          isSubmitting: false 
        });
        
        // Redirect to thank you page
        setTimeout(() => {
          this.setState({ redirect: true });
        }, 1000);
      } else {
        console.error('Form submission failed. Response:', response);
        console.error('Result:', result);
        alert('There was an error submitting the form. Please try again.');
        this.setState({ isSubmitting: false });
      }
    } catch (error) {
      console.error('Network error:', error);
      alert('There was a network error. Please check your connection and try again.');
      this.setState({ isSubmitting: false });
    }
  }

	render() {
		if(this.state.redirect) return <Redirect to={'thankyou'} />
		
		return (
			<form onSubmit={this.handleSubmit}>
				{/* Honeypot field for spam protection */}
				<input type="checkbox" name="botcheck" style={{display: 'none'}} />
				
				<div className="tiny-padding">
					<input 
						type="text" 
						name="name" 
						placeholder="Name" 
						value={this.state.name} 
						onChange={this.handleChange}
						required
					/>
				</div>
				{this.props.email &&
					<div className="tiny-padding">
						<input 
							type="email" 
							name="email" 
							placeholder="Email" 
							value={this.state.email} 
							onChange={this.handleChange} 
							required
						/>
					</div>
				}
				{this.props.phone &&
					<div className="tiny-padding">
						<input 
							type="tel" 
							name="phone" 
							placeholder="Phone" 
							value={this.state.phone} 
							onChange={this.handleChange} 
						/>
					</div>
				}
				{this.props.gift &&
					<div className="tiny-padding">
						<h6 className="white" style={{marginBottom:"10px"}}><b>{'Is this a gift?'}</b></h6>
						<select value={this.state.isGift} name="type" type="select" onChange={this.handleChange}>
							<option value="no">{'No'}</option>
							<option value="yes">{'Yes'}</option>
						</select>
					</div>
				}
				<div className="row">
					{this.props.type &&
						<div className="small-12 medium-6">
							<div className="tiny-padding">
								<h6 className="white" style={{marginBottom:"10px"}}><b>{'Type'}</b></h6>
								<select value={this.state.type} name="type" type="select" onChange={this.handleChange}>
									<option value="private">{'Private'}</option>
									<option value="duet">{'Duet'}</option>
									<option value="group">{'Group'}</option>
								</select>
							</div>
						</div>
					}
					{this.props.location &&
						<div className="small-12 medium-6">
							<div className="tiny-padding">
								<h6 className="white" style={{marginBottom:"10px"}}><b>{'Location'}</b></h6>
								<select value={this.state.location} name="location" type="select" onChange={this.handleChange}>
									<option value="in-person">{'In-person'}</option>
									<option value="online">{'Online'}</option>
								</select>
							</div>
						</div>
					}
				</div>
				{this.props.message &&
					<div className="tiny-padding">
						<textarea 
							name="message" 
							placeholder="Message" 
							value={this.state.message} 
							rows="5" 
							onChange={this.handleChange}
						></textarea>
					</div>
				}
				<div className="tiny-padding">
					<input 
						type="submit" 
						className="primary-background white" 
						value={this.state.isSubmitting ? 'Sending...' : this.props.buttonText} 
						style={{fontWeight:"bold"}} 
						id="submit-button"
						disabled={this.state.isSubmitting}
					/>
				</div>
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/contactForm/index.js